var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{class:("px-3 py-5 font-medium text-14px table-row-text " + (_vm.className
        ? _vm.className
        : _vm.type == 'permission' && 'permission-border text-center'))},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }